export const BUILD_VERSION = '826962f5c7d88b7bc0eeb344ff6b9fafde3fbe24';
